const ConfigurableColLayout = ({data, children}: any) => {
    let col = `col-lg-${data.data.size}`

    return (
        <div className={col}>{children}</div>
    )
}

export default ConfigurableColLayout